// extracted by mini-css-extract-plugin
export var currencyInput = "_n0-1";
export var currencySymbol = "_n0-0";